import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var uniqueIdForComponents = 0;
export var generateComponentId = function generateComponentId(id) {
  var _context, currentId;
  return _concatInstanceProperty(_context = "".concat(id, "_")).call(_context, (currentId = uniqueIdForComponents, uniqueIdForComponents += 1, currentId));
};